import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {InvoicesPage} from './pages/InvoicesPage';

export default function RegistrationDataListPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/invoices" component={InvoicesPage} />
            </Switch>
        </Suspense>
    );
}
